export const convertToIsoFomat = (date) => {
  let time = date.format("YYYY-MM-DD");
  return time + "T00:00:00.00Z";
};
